import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  show: false,
  phonevalid: false,
  countryExpectedLength: 0
};
export const CompanyReducerInner = createSlice({
  name: "company",
  initialState: initialState,
  reducers: {
    show(state, action) {
      state.show = action.payload;
    },
    phonevalid(state, action) {
      state.phonevalid = action.payload;
    },
    countryExpectedLength(state, action) {
      state.countryExpectedLength = action.payload;
    }
  }
});
